import React from "react"
import QRCode from "qrcode.react"

type QRGeneratorProps = {
  value: string
  bgColor: string
  size?: number
}

const QRGenerator: React.FC<QRGeneratorProps> = ({ value, bgColor, size }) => {
  return (
    <div
      style={{
        display: "inline-block",
        overflow: "hidden",
        borderRadius: "10%", // Makes the QR code rounded
        width: size || 70, // Ensure the wrapper matches the QR code size
        height: size || 70, // Ensure the wrapper matches the QR code size
      }}
    >
      <QRCode
        value={value || "Default QR Code"} // Default value if none is provided
        size={size ? size : 70}
        bgColor={"#ffffff"}
        fgColor={bgColor} // Foreground color
        includeMargin={true}
      />
    </div>
  )
}

export default QRGenerator
